import { MenuItem, Select } from '@material-ui/core';
import React from 'react';
import { useUnsafeTranslation } from '../../../i18next';

export type Unit = 'bef' | 'aft';
export const SelectBeforeAfter = ({
  value,
  onChange
}: {
  value: Unit;
  onChange: (nextValue: Unit) => void;
}) => {
  const { t } = useUnsafeTranslation();
  return (
    <Select
      variant="outlined"
      value={value}
      onChange={(ev) => {
        const nextUnit = ev.target.value as Unit;
        return onChange(nextUnit);
      }}
    >
      <MenuItem value="bef">{t('before')}</MenuItem>
      <MenuItem value="aft">{t('after')}</MenuItem>
    </Select>
  );
};
